<template>
    <div>
        <h2 class="primary darken-2 white--text font-weight-bold subheading py-2 text-xs-center">CREATE NEW CAMPAIGN</h2>
        <v-divider></v-divider>
        <v-card color="white pa-3" style="">
            <p class="dark--text pa-0 ma-0 text-xs-center">With Campaigns you save with attainable objectives.</p>
            <v-layout wrap row>
                <v-flex xs12 md10 offset-md1>
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-piggy-bank fa-2x mt-3"> </i>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-text-field class="pa-0 mt-3"
                                ref="campaign_name" v-model="campaignName"
                                label="Enter Campaign Name"
                                :rules="[v => !!v || 'Campaign Name is required']"
                                color="teal"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                            <v-btn @click.stop="$store.commit('activateDialog', true); campaign_name_help = true; getHelpMessage()" flat fab small outline color="black" class="my-4" style="height:20px; width: 20px">
                                <i class="fas fa-question"> </i>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md10 offset-md1>
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-tag fa-2x mt-3"> </i>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-select
                                @change="OnChangeCampaignType()"
                                class="pt-0 mt-3" color="teal"
                                v-model="campaignType" ref="campaign_type"
                                :items="campaignTypes"
                                :rules="[v => !!v || 'Campaign Types is required']"
                                label="Select Campaign Types"
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs2>
                            <v-btn @click.stop="$store.commit('activateDialog', true); campaign_type_help = true; getHelpMessage()" flat fab small outline color="black" class="my-4" style="height:20px; width: 20px">
                                <i class="fas fa-question"> </i>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md10 offset-md1>
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-money-bill fa-2x mt-3"> </i>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-text-field class="pa-0 mt-3"
                                ref="campaign_target_amount"
                                label="Campaign Amount" v-model="campaignTargetAmount"
                                :disabled='isAmountDisabled' :required='isAmountRequired'
                                color="teal"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                            <v-btn @click.stop="$store.commit('activateDialog', true); campaign_amount_help = true; getHelpMessage()" flat fab small outline color="black" class="my-4" style="height:20px; width: 20px">
                                <i class="fas fa-question"> </i>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md10 offset-md1>
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-calendar fa-2x mt-3"> </i>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-text-field class="pa-0 mt-3"
                                ref="campaign_target_date"
                                label="Campaign Date" v-model="campaignTargetDate"
                                :disabled='isDateDisabled' :required='isDateRequired'
                                type="date"
                                color="teal"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                            <v-btn @click.stop="$store.commit('activateDialog', true); campaign_date_help = true; getHelpMessage()" flat fab small outline color="black" class="my-4" style="height:20px; width: 20px">
                                <i class="fas fa-question"> </i>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md10 offset-md1>
                    <v-layout row>
                        <v-flex xs2 sm1>
                            <i class="teal--text fas fa-pen-to-square fa-2x mt-3"> </i>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-textarea class="pa-0 mt-3"
                                name="input-7-1"
                                auto-grow v-model="campaignDescription"
                                ref="campaign_description"
                                label="Campaign Description"
                                :rules="[v => !!v || 'Campaign Description is required']"
                                background-color="grey lighten-4" color="teal"
                                rows="2" box
                                row-height="20"
                            ></v-textarea>
                        </v-flex>
                        <v-flex xs2>
                            <v-btn @click.stop="$store.commit('activateDialog', true); campaign_description_help = true; getHelpMessage()" flat fab small outline color="black" class="my-4" style="height:20px; width: 20px">
                                <i class="fas fa-question"> </i>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <!-- Delivery Information Section -->
                <v-flex xs12 class="mt-4">
                    <v-divider></v-divider>
                    <h3 class="subheading mb-3 teal--text text--darken-2 mt-3">
                        <v-icon color="teal darken-1" class="mr-2">local_shipping</v-icon>
                        Delivery Information
                    </h3>
                </v-flex>

                <!-- Shipping Town -->
                <v-flex xs12 md10 offset-md1>
                    <v-layout row align-center>
                        <v-flex xs2 sm1>
                            <v-avatar color="teal lighten-5" size="36">
                                <v-icon color="teal darken-1">fas fa-city</v-icon>
                            </v-avatar>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-select
                                v-model="selected_shipping_town"
                                :items="shipping_towns"
                                label="Delivery Town"
                                item-value="id"
                                item-text="name"
                                :rules="[v => !!v || 'Delivery town is required']"
                                @change="getShippingPoints()"
                                color="teal darken-2"
                                hide-details
                            ></v-select>
                        </v-flex>
                        <v-flex xs1>
                            <v-btn @click.stop="showDeliveryHelp()" icon small color="teal darken-2">
                                <v-icon small>help</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <!-- Collection Point -->
                <v-flex xs12 md10 offset-md1 class="mt-3">
                    <v-layout row align-center>
                        <v-flex xs2 sm1>
                            <v-avatar color="teal lighten-5" size="36">
                                <v-icon color="teal darken-1">fas fa-map-marker-alt</v-icon>
                            </v-avatar>
                        </v-flex>
                        <v-flex xs9 sm10>
                            <v-select
                                v-model="selected_shipping_location"
                                :items="shipping_collection_points"
                                label="Collection Point"
                                item-value="id"
                                item-text="name"
                                :rules="[v => !!v || 'Collection point is required']"
                                @change="updateCampaignAmountWithDelivery()"
                                color="teal darken-2"
                                hide-details
                            ></v-select>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <!-- Delivery Summary -->
                <v-flex xs12 md10 offset-md1 v-if="delivery_fee_amount > 0" class="mt-4">
                    <v-card flat color="grey lighten-4" class="elevation-1">
                        <v-card-text class="pa-3">
                            <v-layout row wrap align-center>
                                <v-flex xs6 class="pr-2">
                                    <div class="text-xs-center">
                                        <v-icon color="teal darken-1" small class="mb-1">local_shipping</v-icon>
                                        <div class="caption grey--text text--darken-1">Delivery Fee</div>
                                        <div class="subheading font-weight-bold">{{delivery_fee_amount}} FCFA</div>
                                    </div>
                                </v-flex>
                                <v-flex xs6 class="pl-2">
                                    <div class="text-xs-center">
                                        <v-icon color="teal darken-1" small class="mb-1">schedule</v-icon>
                                        <div class="caption grey--text text--darken-1">Delivery Time</div>
                                        <div class="subheading font-weight-bold">{{delivery_time}}</div>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <v-divider class="my-2"></v-divider>
                            <div class="text-xs-center">
                                <div class="caption grey--text text--darken-1">Product Price</div>
                                <div class="subheading">{{productPrice}} FCFA</div>
                                <div class="caption grey--text text--darken-1 mt-2">+ Delivery Fee</div>
                                <div class="subheading">{{delivery_fee_amount}} FCFA</div>
                                <v-divider class="my-2"></v-divider>
                                <div class="title teal--text text--darken-2 font-weight-bold">Total Campaign Amount: {{campaignTargetAmount}} FCFA</div>
                                <p class="caption teal--text text--darken-1 mt-1">Your savings target includes product price + delivery fee</p>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <div class="text-xs-center mt-4">
                <v-btn @click="validateAndConfirm()" class="white--text elevation-6" type="submit" small round color="teal">
                    <span>Submit</span>
                </v-btn>
            </div>

            <!-- Campaign Funds Usage Confirmation Dialog -->
            <v-dialog v-model="showFundsConfirmation" max-width="500" persistent>
                <v-card class="confirmation-dialog-simple">
                    <v-card-text class="confirmation-content-simple text-xs-center pa-4">
                        <div class="simple-icon mb-3">
                            <v-icon size="64" color="teal" class="icon-gentle">savings</v-icon>
                        </div>

                        <h3 class="simple-title teal--text mb-3">Secure Savings for Your Goal 🎯</h3>

                        <div class="simple-message">
                            <p class="mb-3">Your campaign funds are <strong>protected</strong> and will be automatically used to purchase your selected product when your goal is reached.</p>

                            <div class="key-point">
                                <v-icon small color="teal" class="mr-2">lock</v-icon>
                                <span>Funds are dedicated to your product</span>
                            </div>

                            <div class="key-point">
                                <v-icon small color="teal" class="mr-2">local_shipping</v-icon>
                                <span>Delivery fee included in your savings target</span>
                            </div>

                            <div class="key-point">
                                <v-icon small color="teal" class="mr-2">autorenew</v-icon>
                                <span>Full refund if product becomes unavailable</span>
                            </div>
                        </div>

                        <!-- Delivery Info in Confirmation -->
                        <v-card v-if="delivery_fee_amount > 0" flat color="teal lighten-5" class="mt-4 pa-3">
                            <div class="text-xs-center">
                                <div class="caption grey--text text--darken-2">Delivery Summary</div>
                                <v-layout row wrap class="mt-2">
                                    <v-flex xs6>
                                        <div class="caption">Town:</div>
                                        <div class="body-2 font-weight-bold">{{selectedShippingTownName}}</div>
                                    </v-flex>
                                    <v-flex xs6>
                                        <div class="caption">Point:</div>
                                        <div class="body-2 font-weight-bold">{{selectedShippingLocationName}}</div>
                                    </v-flex>
                                </v-layout>
                                <div class="mt-2">
                                    <div class="caption">Delivery Fee: {{delivery_fee_amount}} FCFA</div>
                                    <div class="caption">Est. Delivery: {{delivery_time}}</div>
                                </div>
                            </div>
                        </v-card>

                        <div class="reassurance-note mt-4">
                            <v-icon small color="green" class="mr-1">verified</v-icon>
                            <span class="caption green--text">Your money is safe with us</span>
                        </div>
                    </v-card-text>
                    <v-card-actions class="confirmation-actions-simple pa-3">
                        <v-btn
                            @click="showFundsConfirmation = false"
                            text
                            small
                            class="cancel-btn-simple"
                        >
                            Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="confirmCampaignCreation"
                            color="teal"
                            class="white--text confirm-btn-simple"
                            small
                            depressed
                        >
                            <v-icon left small>rocket_launch</v-icon>
                            Start Saving
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Welcome Dialog (existing) -->
            <v-dialog width="500px" v-model="Dialog">
                <v-card>
                    <v-card-title class="headline primary darken-2 white--text" primary-title>Welcome To PettyCash</v-card-title>
                    <v-card-text class="pa-2">
                        <p class="mb-0">In order to start using our services, you will create your very first savings campaign</p>
                        <div>
                            <p class="mb-0">Note that we have 3 campaign types (Money based, Time based and Money-Time based).</p>
                            <p class="pl-2 mb-0 pt-1"> - Money Based campaigns have money as their savings target with minimum being 25,000 F CFA</p>
                            <p class="pl-2 mb-0 pt-1"> - Time Based campaigns have time as their savings target with minimum being 1 month</p>
                            <p class="pl-2 mb-0 pt-1"> - Click <b class="teal--text darken-2">Start Now</b> below to begin</p>
                        </div>
                    </v-card-text>

                    <v-card-actions class="px-3 text-xs-right">
                        <v-spacer></v-spacer>
                        <v-btn color="teal darken-2" class="white--text" @click="Dialog = false">Start Now</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            isAmountDisabled: false,
            isDateDisabled: false,
            isAmountRequired: false,
            isDateRequired: false,
            campaign_name_help: false,
            campaign_type_help: false,
            campaign_amount_help: false,
            campaign_date_help: false,
            campaign_description_help: false,
            campaignName: "",
            campaignType: "",
            campaignTargetAmount: "",
            campaignTargetDate: "",
            campaignDescription: "",
            campaignTypes: [],
            Dialog: false,
            showFundsConfirmation: false,

            // Delivery Information
            shipping_towns: [],
            shipping_collection_points: [],
            shipping_data: [],
            selected_shipping_town: "",
            selected_shipping_location: "",
            delivery_time: "",
            delivery_fee_amount: 0,
            productPrice: 0,
            product: null,

            // For confirmation dialog display
            selectedShippingTownName: "",
            selectedShippingLocationName: "",
        }
    },

    mounted() {
        this.getCampaignTypes();
        this.getMarketItemInfo();
        this.getShippingTowns();

        this.$store.commit('setCloseURL', "/savings/campaigns/active")
        document.title = "PettyCash | Create New Campaign"

        if (sessionStorage.getItem('url').search("signup") === -1) {
            this.Dialog = false
        } else {
            this.Dialog = true
        }
    },

    methods: {
        async getMarketItemInfo() {
            this.$store.commit('setIsLoading', true)
            const product_id = this.$store.state.save_item

            if (product_id !== "") {
                await axios
                    .get('/api/v1/market_place/get/product/details/' + product_id + '/')
                    .then(response => {
                        console.log(response.data)
                        this.product = response.data["product_info"]
                        this.campaignName = "Saving to buy " + this.product.name
                        this.productPrice = this.product.price
                        this.campaignTargetAmount = this.product.price
                        this.campaignDescription = "I am saving to buy a " + this.product.name + " of amount " + this.product.price + " F CFA"
                        this.campaignType = "MONEY_TARGET"

                        this.isAmountDisabled = false
                        this.isDateDisabled = true
                        this.isAmountRequired = false
                        this.isDateRequired = true
                    })
                    .catch(error => {
                        if (error.response) {
                            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        } else {
                            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }
                    })
            }
            this.$store.commit('setIsLoading', false)
        },

        async getCampaignTypes() {
            this.$store.commit('setIsLoading', true)

            await axios
                .get('/api/v1/savings/get/campaign/types/')
                .then(response => {
                    this.campaignTypes = response.data
                })
                .catch(error => {
                    if (error.response) {
                        this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                        this.$store.commit('setSnackBarColor', "red darken-4")
                        this.$store.commit('activateSnackBar', true)
                    } else {
                        this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                        this.$store.commit('setSnackBarColor', "red darken-4")
                        this.$store.commit('activateSnackBar', true)
                    }
                })

            this.$store.commit('setIsLoading', false)
        },

        // Get shipping towns
        async getShippingTowns() {
            this.$store.commit('setIsLoading', true)

            try {
                const response = await axios.get('/api/v1/market_place/get/shipping/towns')
                this.shipping_towns = response.data
            } catch (error) {
                if (error.response) {
                    this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                    this.$store.commit('setSnackBarColor', "red darken-4")
                    this.$store.commit('activateSnackBar', true)
                } else {
                    this.$store.commit('setSnackBarMessage', "An error occurred while loading shipping towns. Please try again.")
                    this.$store.commit('setSnackBarColor', "red darken-4")
                    this.$store.commit('activateSnackBar', true)
                }
            }

            this.$store.commit('setIsLoading', false)
        },

        // Get shipping collection points
        async getShippingPoints() {
            if (!this.selected_shipping_town) {
                this.showError("Please select a delivery town first")
                return
            }

            this.$store.commit('setIsLoading', true)
            this.selected_shipping_location = ""
            this.delivery_fee_amount = 0
            this.delivery_time = ""

            try {
                const response = await axios.get(`/api/v1/market_place/get/shipping/points/${this.selected_shipping_town}`)

                if (response.data && response.data.length > 0) {
                    this.shipping_collection_points = response.data
                    this.shipping_data = response.data

                    // Get town name for display
                    const selectedTown = this.shipping_towns.find(town => town.id === this.selected_shipping_town)
                    this.selectedShippingTownName = selectedTown ? selectedTown.name : ""
                } else {
                    this.showError("No collection points available for this town")
                    this.shipping_collection_points = []
                    this.shipping_data = []
                }
            } catch (error) {
                if (error.response) {
                    this.showError(`${error.response.status} ${error.response.statusText}`)
                } else {
                    this.showError("Network error. Please check your internet connection.")
                }
                this.shipping_collection_points = []
                this.shipping_data = []
            } finally {
                this.$store.commit('setIsLoading', false)
            }
        },

        // Update campaign amount with delivery fee
        updateCampaignAmountWithDelivery() {
            const location = this.shipping_data.find(
                item => item.id === this.selected_shipping_location
            )

            if (location) {
                this.delivery_fee_amount = location.fee
                this.delivery_time = `${location.time_interval_days} days`

                // Update campaign amount: product price + delivery fee
                this.campaignTargetAmount = Number(this.productPrice) + Number(location.fee)

                // Update description to include delivery
                this.campaignDescription = `I am saving to buy a ${this.product.name} of amount ${this.productPrice} F CFA + ${location.fee} F CFA delivery fee`

                // Get location name for display
                this.selectedShippingLocationName = location.name
            }
        },

        // Validate form including delivery information
        validateAndConfirm() {
            if (this.validateForm()) {
                this.showFundsConfirmation = true;
            }
        },

        validateForm() {
            var future = new Date();
            future.setDate(future.getDate() + 30);

            if (this.campaignName === "") {
                this.showError("Please fill in the campaign name")
                this.$refs.campaign_name.focus()
                return false;
            } else if (this.campaignType === "") {
                this.showError("Please select the campaign type")
                this.$refs.campaign_type.focus()
                return false;
            }

            // Delivery validation
            else if (!this.selected_shipping_town) {
                this.showError("Please select a delivery town")
                return false;
            } else if (!this.selected_shipping_location) {
                this.showError("Please select a collection point")
                return false;
            }

            // Amount validation
            else if ((this.campaignType === "MONEY_TARGET" || this.campaignType === "MONEY_TIME_TARGET") && Number(this.campaignTargetAmount) < 15000) {
                this.showError("Sorry your amount target for this campaign must be at least <b>15000</b>.")
                this.$refs.campaign_target_amount.focus()
                return false;
            }

            // Date validation
            else if ((this.campaignType === "TIME_TARGET" || this.campaignType === "MONEY_TIME_TARGET") && new Date(this.campaignTargetDate) < future) {
                this.showError("Sorry your campaign date must be at least <b>30 days from now</b>.")
                this.$refs.campaign_target_date.focus()
                return false;
            }

            // Required fields validation
            else if (this.campaignType === "MONEY_TARGET" && this.campaignTargetAmount === "") {
                this.showError("Please input your campaign target amount")
                this.$refs.campaign_target_amount.focus()
                return false;
            } else if (this.campaignType === "TIME_TARGET" && this.campaignTargetDate === "") {
                this.showError("Please select your campaign target date")
                this.$refs.campaign_target_date.focus()
                return false;
            } else if (this.campaignType === "MONEY_TIME_TARGET" && this.campaignTargetDate === "") {
                this.showError("Please select your campaign target date")
                this.$refs.campaign_target_date.focus()
                return false;
            } else if (this.campaignType === "MONEY_TIME_TARGET" && this.campaignTargetAmount === "") {
                this.showError("Please input your campaign target amount")
                this.$refs.campaign_target_amount.focus()
                return false;
            } else if (this.campaignDescription === "") {
                this.showError("Please input your campaign description")
                this.$refs.campaign_description.focus()
                return false;
            }
            return true;
        },

        // Confirm campaign creation
        confirmCampaignCreation() {
            this.showFundsConfirmation = false;
            this.createNewCampaign();
        },

        async createNewCampaign() {
            this.$store.commit('setIsLoading', true)
            const product_id = this.$store.state.save_item

            // Find selected location data
            const location = this.shipping_data.find(
                item => item.id === this.selected_shipping_location
            )

            const formData = {
                'productID': product_id,
                'campaignName': this.campaignName,
                'campaignType': this.campaignType,
                'campaignTargetAmount': this.campaignTargetAmount,
                'campaignTargetDate': this.campaignTargetDate,
                'campaignDescription': this.campaignDescription,
                // Delivery information
                'shipping_town_id': this.selected_shipping_town,
                'shipping_location_id': this.selected_shipping_location,
                'delivery_fee': location ? location.fee : 0,
                'delivery_time_days': location ? location.time_interval_days : 0
            }

            console.log("Creating campaign with data:", formData)

            await axios
                .post('/api/v1/market_place/create/new_campaign/', formData)
                .then(response => {
                    this.$store.commit('setSnackBarMessage', response.data[0].text)
                    this.$store.commit('setSnackBarColor', response.data[0].color)
                    this.$store.commit('activateSnackBar', true)
                    if (response.data[0].id !== 0) {
                        let router = this.$router
                        setTimeout(function () {
                            router.push('/market_place/campaign/detail/' + response.data[0].id + '/')
                        }, 4000)
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                        this.$store.commit('setSnackBarColor', "red darken-4")
                        this.$store.commit('activateSnackBar', true)
                    } else {
                        this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                        this.$store.commit('setSnackBarColor', "red darken-4")
                        this.$store.commit('activateSnackBar', true)
                    }
                })
            this.$store.commit('setIsLoading', false)
        },

        showDeliveryHelp() {
            this.$store.commit('setDialogTitle', "Delivery Information")
            this.$store.commit('setDialogMessage', "Select your delivery town and collection point. The delivery fee will be automatically added to your campaign target amount. This ensures that when your savings goal is reached, your product will be delivered to your chosen location.")
            this.$store.commit('activateDialog', true)
        },

        getHelpMessage() {
            if (this.campaign_name_help) {
                this.campaign_name_help = false
                this.$store.commit('setDialogTitle', "Campaign Name")
                this.$store.commit('setDialogMessage', "Here you are required to input your campaign name. This name is usually descriptive of the objective for your savings.")
                this.$store.commit('activateDialog', true)
            } else if (this.campaign_type_help) {
                this.campaign_type_help = false
                this.$store.commit('setDialogTitle', "Campaign Type")
                this.$store.commit('setDialogMessage', "You are required to choose your campaign type here. We have 4 types of campaigns, (Periodic, Money and Money-Time Target). If your target is a certain amount, choose the MONEY TARGET option. If your target is certain date then you choose TIME TARGET. If your target is a certain amount at a particular time, then choose MONEY-TIME TARGET. In the case of you having no idea, you can choose UNDEFINED.")
                this.$store.commit('activateDialog', true)
            } else if (this.campaign_amount_help) {
                this.campaign_amount_help = false
                this.$store.commit('setDialogTitle', "Campaign Amount")
                this.$store.commit('setDialogMessage', "If you have a certain amount saved as your campaign objective, you will have to input your targeted amount.")
                this.$store.commit('activateDialog', true)
            } else if (this.campaign_date_help) {
                this.campaign_date_help = false
                this.$store.commit('setDialogTitle', "Campaign Date")
                this.$store.commit('setDialogMessage', "If you have a certain date saved as your campaign objective, you will have to input your targeted date.")
                this.$store.commit('activateDialog', true)
            } else if (this.campaign_description_help) {
                this.campaign_description_help = false
                this.$store.commit('setDialogTitle', "Campaign Description")
                this.$store.commit('setDialogMessage', "This entails for you to input the description of why you are setting the objective based savings campaign.")
                this.$store.commit('activateDialog', true)
            }
        },

        OnChangeCampaignType() {
            if (this.campaignType === "MONEY_TARGET") {
                this.isAmountDisabled = false
                this.isDateDisabled = true
                this.isAmountRequired = false
                this.isDateRequired = true
            } else if (this.campaignType === "TIME_TARGET") {
                this.isAmountDisabled = true
                this.isDateDisabled = false
                this.isAmountRequired = true
                this.isDateRequired = false
            } else if (this.campaignType === "MONEY_TIME_TARGET") {
                this.isAmountDisabled = false
                this.isDateDisabled = false
                this.isAmountRequired = false
                this.isDateRequired = false
            } else if (this.campaignType === "UNDEFINED TARGET") {
                this.isAmountDisabled = true
                this.isDateDisabled = true
                this.isAmountRequired = true
                this.isDateRequired = true
            }
        },

        showError(message) {
            this.$store.commit('setSnackBarMessage', message)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
        }
    }
}
</script>

<style scoped>
.confirmation-dialog-simple {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.confirmation-content-simple {
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    padding: 32px 24px;
}

.simple-icon {
    animation: gentleBounce 2s ease-in-out infinite;
}

.icon-gentle {
    filter: drop-shadow(0 4px 8px rgba(0, 150, 136, 0.2));
}

.simple-title {
    font-weight: 600;
    font-size: 1.3rem;
    line-height: 1.3;
}

.simple-message {
    text-align: left;
    color: #555;
    line-height: 1.5;
}

.simple-message p {
    font-size: 0.95rem;
    color: #666;
}

.key-point {
    display: flex;
    align-items: center;
    margin: 12px 0;
    padding: 8px 12px;
    background: rgba(0, 150, 136, 0.05);
    border-radius: 8px;
    border-left: 3px solid teal;
}

.key-point span {
    font-size: 0.9rem;
    color: #444;
}

.reassurance-note {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    background: rgba(76, 175, 80, 0.1);
    border-radius: 20px;
    border: 1px solid rgba(76, 175, 80, 0.2);
}

.confirmation-actions-simple {
    background: white;
    border-top: 1px solid #e0e0e0;
    padding: 16px 24px;
}

.cancel-btn-simple {
    color: #757575;
    font-weight: 500;
    border-radius: 8px;
}

.confirm-btn-simple {
    font-weight: 600;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 150, 136, 0.3);
    transition: all 0.3s ease;
}

.confirm-btn-simple:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 150, 136, 0.4);
}

/* Gentle Animations */
@keyframes gentleBounce {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-5px);
    }
}

/* Form styling */
.form-field {
    transition: all 0.3s ease;
}

.form-field:hover {
    transform: translateX(2px);
}

.v-avatar {
    transition: all 0.3s ease;
}

.form-field:hover .v-avatar {
    transform: scale(1.05);
}

/* Delivery section styling */
.teal--text.text--darken-2 {
    color: #00695c !important;
}

.v-card.elevation-1 {
    border-left: 4px solid #00897b;
}

/* Mobile Responsive */
@media (max-width: 599px) {
    .confirmation-content-simple {
        padding: 24px 16px;
    }

    .simple-title {
        font-size: 1.2rem;
    }

    .key-point {
        padding: 6px 10px;
    }

    .confirmation-actions-simple {
        padding: 12px 16px;
    }

    .v-flex.xs2.sm1 {
        min-width: 40px;
    }
}
</style>